import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
    <div className="prose prose-sm max-w-none text-gray-700">{children}</div>
  </section>
);

const PrivacyPolicyPage = () => {
  const lastUpdated = new Date().toISOString().slice(0, 10);

  return (
    <div className="container mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mt-1">Last updated: {lastUpdated}</p>
      </header>

      <div className="bg-white rounded-lg shadow-sm border p-6 md:p-8">
        <Section title="Overview">
          <p>
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use CureHive Nepal's website and services.
          </p>
        </Section>

        <Section title="Information We Collect">
          <ul>
            <li>Account details: name, email, password, profile info (from your account).</li>
            <li>Order and cart data: items in cart, addresses, and order history.</li>
            <li>Communication data: messages via chat, notifications, and email interactions.</li>
            <li>Search and browsing data: searches, viewed products, brands, categories.</li>
            <li>Payment references: payment confirmations/attachments you upload (stored securely).</li>
            <li>Technical data: device, browser, IP, and analytics (including Meta Pixel events).</li>
          </ul>
        </Section>

        <Section title="How We Use Your Information">
          <ul>
            <li>Authenticate and manage your account (login, verification, profile).</li>
            <li>Process orders, manage cart, wishlist, and order notifications.</li>
            <li>Provide chat support and customer service.</li>
            <li>Improve search, recommendations, categories, and product browsing.</li>
            <li>Send transactional notifications and relevant updates.</li>
            <li>Analyze site usage and measure campaign performance via analytics and Meta Pixel.</li>
          </ul>
        </Section>

        <Section title="Sharing of Information">
          <ul>
            <li>Service providers: payment processing references, hosting, and analytics.</li>
            <li>Vendors/fulfillment partners: to fulfill your orders where applicable.</li>
            <li>Legal compliance: when required by law or to protect our rights.</li>
          </ul>
        </Section>

        <Section title="Cookies and Tracking">
          <p>
            We use cookies and similar technologies for session management, analytics, and personalization. We also implement Meta Pixel to understand user interactions and improve marketing effectiveness. You can control cookies via your browser settings.
          </p>
        </Section>

        <Section title="Data Retention">
          <p>
            We retain your information for as long as needed to provide services, comply with legal obligations, resolve disputes, and enforce our agreements. You can request deletion of your account data subject to legal requirements.
          </p>
        </Section>

        <Section title="Your Rights">
          <ul>
            <li>Access, update, or delete your account information.</li>
            <li>Manage email preferences and push notifications.</li>
            <li>Request a copy of your data and how it's used.</li>
          </ul>
        </Section>

        <Section title="Security">
          <p>
            We implement reasonable technical and organizational measures to protect your data, including secure file storage for uploads and role-based access controls. However, no method of transmission over the Internet is 100% secure.
          </p>
        </Section>

        <Section title="Children's Privacy">
          <p>
            Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13.
          </p>
        </Section>

        <Section title="International Transfers">
          <p>
            Your information may be processed in systems hosted outside your country. We take steps to ensure appropriate safeguards are in place.
          </p>
        </Section>

        <Section title="Contact Us">
          <p>
            For privacy requests or questions, contact us at the email and phone listed in the footer Contact Us section.
          </p>
        </Section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;


